import { Link } from "react-router-dom";

export const Logo = ({ className = "h-10", testid = "site-logo" }) => (
  <Link to="/" data-testid={testid} aria-label="Onkaal.com home" className="inline-flex items-center">
    <img src="/logo-full.webp" alt="Onkaal.com — At your doorstep services" className={`${className} w-auto`} width="490" height="145" />
  </Link>
);
